import styled from '@emotion/styled'

const PageContainer = styled.div`
    margin: 80px 0 0 0;
    padding: 0 24px;
    position: relative;
`

export default PageContainer
